module.exports = __webpack_public_path__ + "img/excel.0724aaca.svg";